import {BifrostBackendApi, BifrostBackendNestApi} from "../gateways/BifrostBackendApi";
import { store } from "../store";

const PaymentProvider = {
	initPayment(amount, urlAccept, urlCancel) {
		return BifrostBackendApi.post("/payments/init",
			{
				amount: amount,
				urlAccept: urlAccept,
				urlCancel: urlCancel
			},
			{
				headers: { Authorization: store.getters.jwtToken }
			}
		).then(response => {
			return response.data;
		});
	},

	getOrderNumberByPayment(tnxId) {
		return BifrostBackendApi.get("/payments/get", {
			params: {tnxId}
		}).then(response => {
			return response.data;
		});
	},

	savePayment(queryData, method = "get") {
		const useNestOrderPaymentFlow = store.getters.featureToggles && store.getters.featureToggles.useNestOrderPaymentFlow;
		const api = useNestOrderPaymentFlow ? BifrostBackendNestApi : BifrostBackendApi;
		const url = useNestOrderPaymentFlow ? "/payments/authorise" : "/payments/save";
		const selectedMethod = ["get", "post"].includes(method) ? method : "get";
		
		return api[selectedMethod](url, { ...queryData }).then(response => response.data);
	},
	capturePayment(txnId, amount) {
		return BifrostBackendApi.post("/payments/capture", {
			txnId: txnId,
			amount: amount
		}, {
			headers: { Authorization: store.getters.jwtToken }
		}).then(response => {
			return response.data;
		});
	},

	async refundPayment({txnId, amountCents, refundSecretCode}) {
		const response = await BifrostBackendApi.post("/payment-api/refund", {
			txnId: txnId,
			amountCents: amountCents
		}, {
			headers: {
				Authorization: store.getters.jwtToken,
				refundSecretCode
			}
		});

		return response.data;
	}
};

export default Object.freeze(PaymentProvider);
